exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-invalid {\n  border-color: red;\n}\n\n#job-selector-dialog {\n    min-height: 200px;\n}\n\n.navbar-form .form-group {\n    display: inline;\n    margin-bottom: 0;\n    vertical-align: middle;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll-selector-dialog/poll-selector-dialog.component.css
// module id = ../../../../../src/app/pages/poll-selector-dialog/poll-selector-dialog.component.css
// module chunks = main